<template>
  <div
    @click="handleNavigation"
    v-html="footerLink2.content" />
</template>

<script>
export default {
  props: {
    footerLink2: {
      type: [String, Object],
      default: '',
    },
  },
  methods: {
    handleNavigation(event) {
      const target = event.target.closest('[data-link]');
      if (target) {
        event.preventDefault();
        this.$router.push(target.dataset.link);
      }
    },
  },
};
</script>
